import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcWarningOl = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 21.875C17.4538 21.875 21.875 17.4538 21.875 12C21.875 6.54619 17.4538 2.125 12 2.125C6.54619 2.125 2.125 6.54618 2.125 12C2.125 17.4538 6.54619 21.875 12 21.875ZM20.125 12C20.125 16.4873 16.4873 20.125 12 20.125C7.51269 20.125 3.875 16.4873 3.875 12C3.875 7.51268 7.51269 3.875 12 3.875C16.4873 3.875 20.125 7.51268 20.125 12ZM12 14.5C11.1716 14.5 10.5 15.1716 10.5 16C10.5 16.8284 11.1716 17.5 12 17.5C12.8284 17.5 13.5 16.8284 13.5 16C13.5 15.1716 12.8284 14.5 12 14.5ZM11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12L13 8C13 7.44771 12.5523 7 12 7C11.4477 7 11 7.44771 11 8L11 12Z",
		fill: "inherit"
	})
});
export default SvgIcWarningOl;
